export default "__VITE_ASSET__2485bff9__"